export const isValidPhoneNumber = (value) => {
	if (!value) {
		return false
	}
	if (value && value[0] !== '+') {
		return false
	}
	return /^\d{7,}$/.test(value.replace(/[\s()+\-.]|ext/gi, ''))
}
